import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../store';
import { formatCurrency } from '../../../utils/formatters.util';
import { CartSummary } from '@types';

const useCartSummary = () => {
  const { summary, items } = useSelector((state: AppState) => state.cartItemList);
  const { data: cartEstimatedAmountsData } = useSelector((state: any) => state.cartEstimatedAmounts);

  const [displaySummary, setDisplaySummary] = useState<CartSummary>(summary || {});

  useEffect(() => {
    if (summary) {
      setDisplaySummary({
        eligibleForFreeShipping:
          cartEstimatedAmountsData?.eligibleForFreeShipping ?? summary.eligibleForFreeShipping,
        amountRemainingForFreeShippingFormatted:
          cartEstimatedAmountsData?.amountRemainingForFreeShippingFormatted ??
          summary.amountRemainingForFreeShippingFormatted,
        meterProgressFormatted:
          cartEstimatedAmountsData?.meterProgressFormatted ?? summary.meterProgressFormatted,
        subtotal: cartEstimatedAmountsData?.subtotal ?? formatCurrency(summary.subtotal),
        discounts: cartEstimatedAmountsData?.discounts ?? summary.discounts,
        discount: cartEstimatedAmountsData?.discount ?? formatCurrency(-summary.discount),
        discountedSubtotal:
          cartEstimatedAmountsData?.discountedSubtotal ?? formatCurrency(summary.discountedSubtotal),
        hasError: !!(items || []).find((i) => !!i.customInfo?.error),
        itemCount: cartEstimatedAmountsData?.itemCount ?? summary.itemCount,
        discountedSubtotalUnformatted: summary.discountedSubtotal,
      });
    }
  }, [summary, cartEstimatedAmountsData]);

  return displaySummary;
};

export default useCartSummary;
